import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../data/content';

const AboutContainer = styled.section`
  background: #ffffff;
  padding: 0;
  min-height: 450px;
  border-top: 2px solid #000000;
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 8px 1fr;
  min-height: 450px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    min-height: auto;
  }
`;

const AboutText = styled.div`
  background: #ffffff;
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 968px) {
    padding: 50px 40px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const GreigeBar = styled.div`
  background: #b7ab9f;
  width: 8px;

  @media (max-width: 968px) {
    display: none;
  }
`;

const AboutTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #333333;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const AboutDescription = styled.div`
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666666;
  margin-bottom: 2rem;
  
  p {
    margin-bottom: 1.2rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const AboutCTA = styled.button`
  background: #b7ab9f;
  color: #ffffff;
  border: 2px solid #b7ab9f;
  padding: 1rem 2.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-self: flex-start;
  margin-top: 1rem;

  &:hover {
    background: transparent;
    color: #b7ab9f;
    transform: translateY(-2px);
  }
`;

const AboutImageContainer = styled.div`
  position: relative;
  background: url('/images/Handshakes.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 450px;

  @media (max-width: 968px) {
    min-height: 350px;
  }
`;

const About = () => {
  const { language } = useLanguage();
  const t = content[language];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 120; // Account for sticky header height
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <AboutContainer id="about">
      <AboutContent>
        <AboutText>
          <AboutTitle className="content-entry-animation">
            {t.about.title}
          </AboutTitle>
          <AboutDescription>
            {t.about.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="content-entry-animation">{paragraph}</p>
            ))}
          </AboutDescription>
          <AboutCTA className="content-entry-animation" onClick={scrollToContact}>
            {language === 'fr' ? 'CONTACTEZ-NOUS' : 'CONTACT US'}
          </AboutCTA>
        </AboutText>
        
        <GreigeBar />
        
        <AboutImageContainer />
      </AboutContent>
    </AboutContainer>
  );
};

export default About; 
